import { saveTag } from './campana.actions'

export const savetags = (tags) => dispatch =>{
    dispatch(saveTag(tags))
}